import React, { useRef } from 'react';
import useOverscrollNavigation from 'customHooks/useOverscrollNavigation';

const ResponsePreviewCarousel = ({
  children,
  scrollRef,
  onScrollPastEnd,
  onScrollPastStart,
  showPreviousOverscroll,
  showNextOverscroll
}: {
  children: React.ReactNode;
  scrollRef?: React.RefObject<HTMLDivElement>;
  onScrollPastEnd?: () => void;
  onScrollPastStart?: () => void;
  showPreviousOverscroll?: boolean;
  showNextOverscroll?: boolean;
}) => {
  const { touchHandlers, OverscrollIndicators } = useOverscrollNavigation({
    onScrollPastEnd,
    onScrollPastStart,
    showPreviousOverscroll,
    showNextOverscroll,
    scrollRef
  });

  // Keep scroll-specific logic for tracking boundaries
  const isAtEnd = useRef(false);
  const isAtStart = useRef(false);

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const element = e.currentTarget;
    const { scrollLeft, scrollWidth, clientWidth } = element;

    // Check if we're at the boundaries
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;
    const atStart = scrollLeft <= 1;

    // Update boundary states
    isAtEnd.current = atEnd;
    isAtStart.current = atStart;
  };

  return (
    <div className="mobile-view-carousel-container">
      <OverscrollIndicators />

      <div
        ref={scrollRef}
        onScroll={handleScroll}
        {...touchHandlers}
        className="mobile-view-carousel-scroll"
      >
        {children}
      </div>
    </div>
  );
};

export default ResponsePreviewCarousel;
